import { MouseEvent, useEffect, useState } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';

import { Section } from '../../../UIPackage/FormModule/components/Section';
import { IKnmErknmFormSubject } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormSubject';
import { KnmEpguNotificationItem } from './KnmEpguNotificationItem';
import { KNM_EPGU_NOTIFICATION, KNM_NOTIFICATION } from '../../../CorePackage/MainModule/routes/routes';
import { scrollToBlock } from '../../../CorePackage/MainModule/common/scrollToBlock';
import styles from './KnmEpguNotification.module.scss';
import { DetailItem } from './DetailItem';
import { createDetailsItems } from '../common/createDetailsItems';

const DETAILS_MODAL_ID = 'detailsModal';

export interface IDetailsItem {
  value?: string;
  field: string;
  items?: IDetailsItem[];
}

interface IKnmEpguNotificationProps {
  organizations: IKnmErknmFormSubject[] | undefined;
  isWatchOnlyByTestUser: boolean;
  type: string;
}

export const KnmEpguNotification = ({ organizations, isWatchOnlyByTestUser, type }: IKnmEpguNotificationProps) => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [details, setDetails] = useState<IDetailsItem[]>([]);
  const [modalPosition, setModalPosition] = useState([0, 0]);

  const handleShowModal = (event: MouseEvent, index: number, structure: string[]) => {
    setModalPosition([event.pageX, event.pageY - 150]);
    setIsShowModal(true);
    setActiveIndex(index);
    setDetails(createDetailsItems(structure));
  };

  const onCloseModal = () => {
    setIsShowModal(false);
  };

  useEffect(() => {
    if (isShowModal) {
      const modalElement = document.getElementById(DETAILS_MODAL_ID);

      if (modalElement && modalPosition[0] + modalElement.offsetWidth > window.screen.width) {
        setModalPosition([window.screen.width - modalElement.offsetWidth, modalPosition[1]]);
      }
    }
  }, [isShowModal, window.screen.width, modalPosition]);

  const scrollToSubjectNotifications = () => {
    scrollToBlock(KNM_NOTIFICATION);
  };

  return (
    <Section
      title="Сведения об информировании контролируемого лица в портал Госуслуги"
      id={KNM_EPGU_NOTIFICATION}
      type="list"
      customButton={
        <Button
          className="shared-btn-add"
          text="Данные об уведомлении контролируемого лица"
          type="button"
          variant="link"
          color="primary"
          onClick={scrollToSubjectNotifications}
          disabled={isWatchOnlyByTestUser}
        />
      }
    >
      <>
        {organizations?.map((item, index) => {
          if (item.isNew) return null;

          return (
            <KnmEpguNotificationItem
              organization={item}
              key={`epguNotification[${index}]`}
              showDetailsModal={(event, structure) => handleShowModal(event, index, structure)}
              closeDetailsModal={onCloseModal}
              isShowDetailsModal={isShowModal && activeIndex === index}
              type={type}
            />
          );
        })}
        {isShowModal && (
          <div
            className={styles.DetailsModal}
            id={DETAILS_MODAL_ID}
            style={{ left: modalPosition[0], top: modalPosition[1] }}
          >
            <div className={styles.DetailsModalHeader}>
              <span>Разделы</span>
              <button className={styles.CloseButton} type="button" onClick={onCloseModal}>
                <span className={styles.CloseButtonIcon} />
              </button>
            </div>
            <div className={styles.DetailsModalBody}>
              {details.map(item => (
                <DetailItem detailItem={item} key={item.field} />
              ))}
            </div>
          </div>
        )}
      </>
    </Section>
  );
};
